// extracted by mini-css-extract-plugin
export default {"emoji_dialog":"emoji-dialog_emoji_dialog__a3J7H","group_section":"emoji-dialog_group_section__uIkcy","emojis_section":"emoji-dialog_emojis_section__d6pXI"};